import { schema } from "normalizr"

const participantSchema = new schema.Entity("participants")

export const lessonSchema = new schema.Entity("lessons", {
  participant: participantSchema,
})
